module.exports = __webpack_public_path__ + "1e9e80b0eec3521c960ce47338956d4e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-10.png
// module id = 2376
// module chunks = 0